module.exports = __webpack_public_path__ + "img/NASAlogo.8cb34f33.png";